export default __webpack_public_path__ + "static/media/scene.973afada.svg";